import { getSSOToken, getAccessToken, getUserId } from '../auth'

let cached = null
let pending = null
let cooldown = null
export const resetAnalyticsAuth = () => { cached = null; pending = null; cooldown = null }
const same = (a, b) => !!a && !!b && a.sso === b.sso && a.access === b.access && a.user === b.user && a.base === b.base
const snapshot = () => ({ sso: getSSOToken(), access: getAccessToken(), user: String(getUserId() || ''), base: String(process.env.REACT_APP_AI_API_URL || '').trim().replace(/\/$/, '') })

async function request(url, body, token) {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), 8000)
  try {
    return await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) }, body: JSON.stringify(body), keepalive: true, signal: controller.signal })
  } finally { clearTimeout(timer) }
}

async function assistantToken(identity) {
  if (same(cached?.identity, identity) && cached.until > Date.now()) return cached.token
  if (same(cooldown?.identity, identity) && cooldown.until > Date.now()) throw new Error('Authentication cooling down')
  if (same(pending?.identity, identity)) return pending.promise
  const ticket = { identity }
  pending = ticket
  ticket.promise = (async () => {
    try {
      // Uses the existing SSO exchange; no Sniper service key is shipped to the PWA.
      const response = await request(`${identity.base}/auth/session`, { ssoToken: identity.sso })
      if (!response.ok) throw new Error('SSO unavailable')
      const data = await response.json()
      if (typeof data.accessToken !== 'string' || !data.accessToken) throw new Error('Invalid session')
      if (pending === ticket && same(snapshot(), identity)) cached = { identity, token: data.accessToken, until: Date.now() + 5 * 60000 }
      return data.accessToken
    } catch (error) {
      if (pending === ticket) cooldown = { identity, until: Date.now() + 60000 }
      throw error
    } finally { if (pending === ticket) pending = null }
  })()
  return ticket.promise
}

export async function sendPlatformActivity(event) {
  const identity = snapshot()
  if (!identity.sso || !identity.access || !identity.user || !identity.base) return
  for (let attempt = 0; attempt < 3; attempt++) {
    if (attempt > 0 && !same(snapshot(), identity)) return
    try {
      const token = await assistantToken(identity)
      // A logout event may finish with the credentials captured before logout.
      if (!same(snapshot(), identity) && event.action !== 'logout') return
      const response = await request(`${identity.base}/analytics/platform-events`, event, token)
      if (response.ok) return
      if (response.status === 401) {
        if (same(cached?.identity, identity)) cached = null
      } else if (response.status < 500 && response.status !== 429) return
    } catch (error) { /* telemetry never interrupts navigation or login */ }
    if (attempt < 2 && same(snapshot(), identity)) await new Promise(resolve => setTimeout(resolve, 1000 * (attempt + 1)))
  }
}
